import { useState, type FormEvent } from 'react';
import { api } from '../api';
import { useAuth } from '../auth/AuthContext';
import { Alert, errorText, Field, PageHeader } from '../components/ui';

/**
 * 센터에 아직 연결되지 않은 치료사(센터 초대로 만든 계정 등)의 첫 화면.
 * 센터장에게 받은 가입 코드를 넣으면 그 센터의 직원 명부에 들어가고 센터 화면이 열린다.
 */
export function Welcome() {
  const { me, afterSignIn } = useAuth();
  const [f, setF] = useState({ name: me?.name ?? '', centerCode: '', independent: false });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await api.onboard(f.independent ? { name: f.name, independent: true } : { name: f.name, centerCode: f.centerCode }); await afterSignIn(); }
    catch (err) { setError(errorText(err)); setBusy(false); }
  };
  return (
    <>
      <PageHeader title="센터 연결" sub="원장님께 받은 가입 코드를 입력하거나 개인 선생님으로 시작하세요." />
      <form className="card stack welcome-form" onSubmit={submit}>
        <Field id="wc-name" label="이름"><input id="wc-name" required maxLength={20} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></Field>
        <label className="teacher-consent"><input type="checkbox" checked={f.independent} onChange={(e) => setF({ ...f, independent: e.target.checked })} /> 소속 센터 없이 개인 선생님으로 활동합니다</label>
        {!f.independent && <Field id="wc-code" label="센터 가입 코드"><input id="wc-code" required maxLength={20} value={f.centerCode} onChange={(e) => setF({ ...f, centerCode: e.target.value })} /></Field>}
        {error && <Alert>{error}</Alert>}
        <button type="submit" className="btn btn-primary" disabled={busy}>{busy ? '확인 중…' : f.independent ? '개인 선생님으로 시작' : '센터에 연결'}</button>
        
      </form>
    </>
  );
}
